module.exports = "function rule(user, context, callback) {\n  var whitelist = ['1.2.3.4', '2.3.4.5']; //authorized IPs\n  var userHasAccess = whitelist.some(function(ip) {\n    return context.request.ip === ip;\n  });\n\n  if (!userHasAccess) {\n    return callback(new UnauthorizedError('Access denied from this IP address.'));\n  }\n\n  return callback(null, user, context);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/pages/jp/homepage/rule-templates/ip-whitelist.js.txt
// module id = 1438
// module chunks = 0